import ScoreDetailsHeader from '../Components/Common/ScoreDetailsHeader';
import EICharacteristicsPanel from './Components/Characteristics/EICharacteristicsPanel';
import UIStrings from '@/Utils/UIStrings';

function EmotionalIntelligenceScoreDetails() {
    return (
        <div className="border-border bg-card rounded-xl border p-5">
            <ScoreDetailsHeader description={UIStrings.EmotionalIntelligenceScoreDetailsHeader} />
            <EICharacteristicsPanel />
        </div>
    );
}

export default EmotionalIntelligenceScoreDetails;
